export const baseUrl = process.env.REACT_APP_BASE_URL;

// urls
export const signUpPost = "api/theater";
export const loginPost = "api/theater/login";
export const applicationPost = "api/theater/application";
export const getOneTheater= "api/admin/getOneTheater";
export const editApplications= "api/admin/editApplications";
export const deleteShowInfo= "api/theater/deleteShowInfo";
export const getscreen= "api/theater/getscreen";
export const getscreens= "api/theater/getscreens";
export const verifyToken = "api/verifyToken";
export const deletScreen= "api/theater/deletScreen";
export const editScreen= "api/theater/editScreen";
export const addscreenpost = "api/theater/addscreen";
export const addShow= "api/theater/addShow";
export const getMovies= "api/theater/listMoveTheater";
export const getAllTheater= "api/theater/getAllTheater";
export const editSreenShow= "api/theater/editSreenShow";
export const ReservationDetailsOneTheater= "api/theater/ReservationDetailsOneTheater";
export const getOnePaymentDetails= "api/theater/getOnePaymentDetails";
export const getOneBookinDetails= "api/theater/getOneBookinDetails";
export const TheaterUserCount= "api/theater/TheaterUserCount";
export const getOneTheaterDayRevenue= "api/theater/getOneTheaterDayRevenue";
export const OnereservationDetails= "api/theater/OnereservationDetails";
export const getReservation= "api/theater/getReservation";
export const getAdmin= "api/theater/getAdmin";
export const getmsg= "api/message/getmsg";
export const addmsg= "api/message/addmsg";
export const getUnreadMEssageAllTheater= "api/admin/getUnreadMEssageAllTheater";
export const readTrueTheater= "api/admin/readTrueTheater";
export const notificationCountTheater= "api/theater/notificationCountTheater";
export const getUnrededMessage= "api/theater/getUnrededMessage";